import { render, staticRenderFns } from "./bg-progress-item.vue?vue&type=template&id=780f9cbe"
import script from "./bg-progress-item.vue?vue&type=script&lang=ts"
export * from "./bg-progress-item.vue?vue&type=script&lang=ts"
import style0 from "./bg-progress-item.vue?vue&type=style&index=0&id=780f9cbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports